import {
  hasUserCreatedClass,
  isProductTourPending,
  shouldShowNewUserWelcomeModal,
} from "./productTour";
import { isSystemOnboardingClass } from "./gettingStartedClass";

export const FIRST_CLASS_PRESENT_WELCOME_FIELD = "firstClassPresentWelcome";

export const FIRST_CLASS_PRESENT_WELCOME_DEFAULTS = {
  pendingAt: null,
  seenAt: null,
};

export const isNewUserOnboardingPending = (user) => {
  if (!user) {
    return false;
  }

  if (user.productTour) {
    return isProductTourPending(user.productTour);
  }

  return user.onboardingIncomplete === true;
};

export const normalizeFirstClassPresentWelcome = (user = {}) => ({
  ...FIRST_CLASS_PRESENT_WELCOME_DEFAULTS,
  ...(user?.[FIRST_CLASS_PRESENT_WELCOME_FIELD] || {}),
});

export const shouldArmFirstClassPresentWelcome = ({
  user = {},
  existingClasses = [],
  createdClasses = [],
} = {}) => {
  const state = normalizeFirstClassPresentWelcome(user);
  if (state.pendingAt || state.seenAt) {
    return false;
  }

  if (hasUserCreatedClass(existingClasses)) {
    return false;
  }

  return (createdClasses || []).some((classItem) => !isSystemOnboardingClass(classItem));
};

export const buildFirstClassPresentWelcomeArmPatch = ({
  user = {},
  existingClasses = [],
  createdClasses = [],
  pendingAt = new Date(),
} = {}) => {
  if (!shouldArmFirstClassPresentWelcome({ user, existingClasses, createdClasses })) {
    return null;
  }

  return {
    [FIRST_CLASS_PRESENT_WELCOME_FIELD]: {
      ...normalizeFirstClassPresentWelcome(user),
      pendingAt,
      seenAt: null,
    },
  };
};

export const shouldShowFirstClassPresentWelcome = ({
  user = {},
  classData = null,
  share = false,
  readOnlyView = false,
  presentReadOnly = false,
} = {}) => {
  if (!user?.uid || share || readOnlyView || presentReadOnly || !classData) {
    return false;
  }

  if (isSystemOnboardingClass(classData)) {
    return false;
  }

  const state = normalizeFirstClassPresentWelcome(user);
  return Boolean(state.pendingAt && !state.seenAt);
};

export const buildFirstClassPresentWelcomeSeenPatch = ({
  user = {},
  seenAt = new Date(),
} = {}) => ({
  [FIRST_CLASS_PRESENT_WELCOME_FIELD]: {
    ...normalizeFirstClassPresentWelcome(user),
    seenAt,
  },
});

export { shouldShowNewUserWelcomeModal };
